(async () => {
  if (!customElements.get('product-recommendations')) {

    const { default: Swiper, Navigation} = await import("swiper");

    Swiper.use([
      Navigation
    ]);
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products]');
        this.swiperTest = '';

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          navigation: {
            nextEl: ".swiper-button-next--recommend",
            prevEl: ".swiper-button-prev--recommend"
          },
          spaceBetween: 16,
          breakpoints: {
            320: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 4
            }
          },
          threshold: 10
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        /**
        * Listen to extra events when in Shopify editor
        */
        if (Shopify.designMode) {

          // Update the swiper when the section event is triggered
          window.addEventListener('shopify:section:load', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          });

        }

        window.onload = () => {
          this.connectedCallback();
        }
      }

      connectedCallback() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const source = html.querySelector('[data-recommended-products]');
            const target = this.querySelector('[data-recommended-products]');

            console.log(source, target);

            if (source && source.innerHTML && source.innerHTML.trim().length) {
              target.innerHTML = source.innerHTML;
            }

            this.swiperInstance.update();
          })
          .catch(e => {
            console.error(e);
          });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);
  }

})();
